import React from 'react';
import '../Hero/Hero.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/swiper-bundle.css';

import DSheildHeroHome from '../../Img/dshield/hero-right.png'
import HarsafeHeroHome from '../../Img/harsafemeethero.png'
import HisaBookHeroHome from '../../Img/hisabbookhero.png'
import ReelsHeroHome from '../../Img/reelsHero.png'

import DshieldHeroBG from '../../Img/bg/dshield-herobg.jpg'
import ChatHeroBG from '../../Img/bg/harsafeherobg.jpg'
import HisabBookHeroBG from '../../Img/bg/hisabbookherobg.png'
import ReelsHeroBG from '../../Img/bg/reelsherobg.jpg'

const sliderData = [
  // {
  //   id: 1,
  //   subHeading: "Protect Your Device with Advanced Mobile Locking Technology",
  //   heading: "Experience Maximum Security with DShield Pro Max",
  //   description: "DShield Pro Max offers robust mobile security, ensuring your device stays locked and protected, preventing unauthorized access at all times.",
  //   buttonText: "DISCOVER NOW",
  //   buttonLink: "/DShield",
  //   imageBGSrc: DshieldHeroBG,
  //   imageSrc: DSheildHeroHome,
  //   imageAlt: "DSheildHeroHomedsf",
  // },
  {
    id: 2,
    subHeading: "We can manage all digital services",
    heading: "Connect Seamlessly with Instant Communication Solutions",
    description: "Experience real-time, secure, and user-friendly communication with Harsafe Meet, designed for personal and professional connections with ease.",
    buttonText: "DISCOVER NOW",
    buttonLink: "/Harsafe_Meet",
    imageBGSrc: ChatHeroBG,
    imageSrc: HarsafeHeroHome,
    imageAlt: "HarsafeHeroHome",
  },
  {
    id: 3,
    subHeading: "We can manage all digital services",
    heading: "Simplify Your Business with Hisab Book",
    description: "Manage your accounts, transactions, and ledgers seamlessly. Hisab Book ensures secure, accurate, and efficient financial tracking, empowering businesses to thrive with smart digital tools at their fingertips. ",
    buttonText: "DISCOVER NOW",
    buttonLink: "/HisabBook",
    imageBGSrc: HisabBookHeroBG,
    imageSrc: HisaBookHeroHome,
    imageAlt: "HisaBookHeroHomedsf",
  },
  {
    id: 4,
    subHeading: "Unleash Your Creativity with Harsafe Reels",
    heading: "Create, Share, and Inspire with Short Videos",
    description: "Explore a vibrant platform to create, watch, and share reels, connecting people through engaging and inspiring short video content.",
    buttonText: "DISCOVER NOW",
    buttonLink: "/Reels_Main",
    imageBGSrc: ReelsHeroBG,
    imageSrc: ReelsHeroHome,
    imageAlt: "ReelsHeroHomedsf",
  },
];

const Hero = () => {
  return (
    <section className="homeSlider homeSliderCar">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="sliderBody">
              <div className="slider">
                <div className="swiper homeMainSlider">
                  <Swiper
                    modules={[Pagination, EffectFade, A11y, Autoplay]}
                    spaceBetween={0}
                    slidesPerView={1}
                    effect="fade"
                    loop={true}
                    autoplay={{ delay: 3000 }}
                    speed={900}
                    pagination={{ clickable: true }}
                    onSwiper={(swiper) => console.log(swiper)}
                    onSlideChange={() => console.log("Slide change")}
                  >
                    {sliderData.map((slide) => (
                      <SwiperSlide key={slide.id} style={{ backgroundImage: `linear-gradient(325deg, rgba(0, 9, 14, 0) 0%, rgba(0, 9, 18, 1) 100%), url(${slide.imageBGSrc})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <div className="sliderItem">
                          <div className="container">
                            <div className="row align-items-center">
                              <div className="col-12 col-lg-6">
                                <span className="subHeading">{slide.subHeading}</span>
                                <h2>{slide.heading}</h2>
                                <p>{slide.description}</p>
                                <a href={slide.buttonLink} className="default-btn">
                                  {slide.buttonText}
                                </a>
                              </div>
                              <div className="col-12 col-lg-6">
                              <div className="hero-img">
                                {slide.imageSrc && (
                                  <img className="hrimg" src={slide.imageSrc} alt={slide.imageAlt} />
                                )}
                              </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="swiper-pagination paginationFix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
